module.exports = __webpack_public_path__ + "static/media/galway-4.d120bc0f.jpg";